import React, { Component } from 'react';

class Genres extends Component{
  componentWillReceiveProps(nextProps){
    let current_genres=nextProps.genres || '';
    //display the current genres user has selected in the input
    current_genres = current_genres.join(', ');
    this.refs.genresdesired.value=current_genres;
  }
  addGenre(e){
    e.preventDefault();
    let genre = e.target.id;
    this.props.addGenre(genre);
  }
  render(){
    return(
      <div className="form-group">
        <label for="genre-input">Genres Desired</label>
        <input className="form-control" ref="genresdesired" type="text" placeholder="click genres below" id="add-genre"></input>
        <div className="form-group add-genres">


        </div>
        <div className="buttons">
        <button id="blues" onClick={this.addGenre.bind(this)} className="btn btn-primary btn-xs" >Blues</button>
        <button id="slow" onClick={this.addGenre.bind(this)} className="btn btn-primary btn-xs">Slow</button>
        <button id="upbeat" onClick={this.addGenre.bind(this)} className="btn btn-primary btn-xs">Upbeat</button>
        <button id="funk" onClick={this.addGenre.bind(this)} className="btn btn-primary btn-xs">Funk</button>
        <button id="sublime" onClick={this.addGenre.bind(this)} className="btn btn-primary btn-xs">Sublime</button>
        <button id="rock" onClick={this.addGenre.bind(this)} className="btn btn-primary btn-xs">Rock</button>
        <button id="folk" onClick={this.addGenre.bind(this)} className="btn btn-primary btn-xs">Folk</button>
        <button id="alternative" onClick={this.addGenre.bind(this)} className="btn btn-primary btn-xs">Alternative</button>
        <button id="jazz" onClick={this.addGenre.bind(this)} className="btn btn-primary btn-xs">Jazz</button>
        <button id="rnb" onClick={this.addGenre.bind(this)} className="btn btn-primary btn-xs">Hip Hop/R&B</button>
        <button id="rap" onClick={this.addGenre.bind(this)} className="btn btn-primary btn-xs">Rap</button>
        <button id="soul" onClick={this.addGenre.bind(this)} className="btn btn-primary btn-xs">Soul</button>
        <button id="other" onClick={this.addGenre.bind(this)} className="btn btn-primary btn-xs">Other</button>
      </div>
      </div>
    );
  }
}


export default Genres;



// WEBPACK FOOTER //
// ./src/components/Genres.js